import { render, staticRenderFns } from "./attendees.vue?vue&type=template&id=ddbe0de2&scoped=true"
import script from "./attendees.vue?vue&type=script&lang=js"
export * from "./attendees.vue?vue&type=script&lang=js"
import style0 from "./attendees.vue?vue&type=style&index=0&id=ddbe0de2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbe0de2",
  null
  
)

export default component.exports